import { render, staticRenderFns } from "./NewPaymentFormCheckbox.vue?vue&type=template&id=d53c96bc&scoped=true&"
import script from "./NewPaymentFormCheckbox.vue?vue&type=script&lang=js&"
export * from "./NewPaymentFormCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./NewPaymentFormCheckbox.vue?vue&type=style&index=0&id=d53c96bc&lang=scss&scoped=true&"
import style1 from "./NewPaymentFormCheckbox.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d53c96bc",
  null
  
)

export default component.exports